import { makeStyles } from "@fluentui/react-components";
import { themeTokens } from "Core/Theme";

export const useClassicVersionButtonStyles = makeStyles({
    root: {},
    button: {
        backgroundColor: themeTokens.versionButtonBackgroundColor,
        border: "none",
        width: "145px",
        height: "32px"
    }
});
